import React from 'react';

import { VideoFormat } from './styled-components';

import Youtube from './Youtube';

const PLAYER = params => ({
  youtube: <Youtube {...params} />
});

const Video = ({ type, videoData }) => {
  return(<>
    <VideoFormat format={videoData.format}>
      {PLAYER(videoData)[type]} 
    </VideoFormat>
  </>)        
};

Video.defaultProps = {
  type: 'youtube',
  videoData: {
    videoId: 'uetFO7y8WPA',
    poster: 'https://picsum.photos/1200/800',
    format: '16:9',
  },
}

export default Video;